module.exports = __webpack_public_path__ + "img/fzlc-7.ba60abfb.png";